<h1 mat-dialog-title class="text-dark text-xl">Carica Documento</h1>
<div mat-dialog-content class="w-full">
  <app-upload-practice-document-form [data]="data"></app-upload-practice-document-form>
</div>
